import React, { useEffect, useState } from "react";
import {
	Box,
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Button,
	InputAdornment,
	IconButton,
	TextField,
	CircularProgress,
	Typography,
	ListItemAvatar,
	ListItem,
	ListItemText,
	List,
	Tooltip,
	ListItemIcon,
	Chip,
	makeStyles,
	useTheme as useMuiTheme
} from "@material-ui/core";
import cockpitActions from "../../../../redux/actions/cockpitActions";

import { useSelector } from "react-redux";
import lod_ from "lodash";
import SearchIcon from "@material-ui/icons/Search";
import ClearIcon from "@material-ui/icons/Clear";
import i18n from "i18n";
import FiltersSearch from "../Filters/FiltersSearch";
import { getChannelsByAssistant } from "helpers/utilities";
import { getLanguagesByAssistant } from "helpers/utilities";
import { api } from "redux/actions/api";
import GetChannelImage from "helpers/GetChannelImage";
import { handleSpecialDisplayDate } from "helpers/utilities";
import { formatDate } from "helpers/utilities";
import { getIntentLabel } from "helpers/utilities";
import C from "../../../../constants/cockpit.js";
import VisibilityIcon from "@material-ui/icons/Visibility";
import NotesComponent from "pages/Cockpit/CockpitTabInfo/Notes";
import MessageItem from "pages/Cockpit/Message/MessageItem";
import Summary from "helpers/Summary";
import { getTsOfMessage } from "helpers/messageUtils";
import { useTheme } from "../../../../theme";
import { api2 } from "redux/actions/api2";

const useStyles = makeStyles(theme => ({
	dialogContent: {
		height: "70vh",
		padding: 0,
		backgroundColor: theme.palette.background.default
	},
	leftColumn: {
		padding: theme.spacing(1),
		display: "flex",
		flexDirection: "column",
		height: "100%",
		overflowY: "auto",
		backgroundColor: theme.palette.background.paper
	},
	rightColumn: {
		width: "60%",
		height: "100%",
		overflowY: "auto",
		backgroundColor: theme.palette.type === "dark" ? "#1a2035" : "rgb(199, 201, 201)"
	},
	searchTextField: {
		"& .MuiOutlinedInput-root": {
			backgroundColor: theme.palette.background.paper,
			"& fieldset": {
				borderColor:
					theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.23)" : "rgba(0, 0, 0, 0.23)"
			},
			"&:hover fieldset": {
				borderColor: theme.palette.primary.main
			},
			"&.Mui-focused fieldset": {
				borderColor: theme.palette.primary.main
			}
		},
		"& .MuiInputBase-input": {
			color: theme.palette.text.primary
		},
		"& .MuiInputAdornment-root": {
			color: theme.palette.text.secondary
		}
	},
	listItem: {
		"&:hover": {
			backgroundColor: theme.palette.action.hover
		},
		borderBottom: `1px solid ${theme.palette.divider}`
	},
	listItemText: {
		"& .MuiListItemText-primary": {
			color: theme.palette.text.primary
		},
		"& .MuiListItemText-secondary": {
			color: theme.palette.text.secondary
		}
	},
	messageContainer: {
		backgroundColor: theme.palette.type === "dark" ? "#2a3550" : "#c7c9c9",
		height: "100%"
	},
	emptyStateText: {
		color: theme.palette.text.primary
	},
	filterLabel: {
		color: theme.palette.text.primary,
		marginBottom: theme.spacing(1)
	},
	iconButton: {
		color: theme.palette.text.secondary,
		"&:hover": {
			color: theme.palette.primary.main
		}
	},
	visibilityIcon: {
		color: theme.palette.type === "dark" ? "rgba(255, 255, 255, 0.7)" : "rgba(0, 0, 0, 0.54)"
	},
	noMessagesBox: {
		display: "flex",
		flexDirection: "column",
		alignItems: "center",
		height: "100%",
		justifyContent: "center",
		color: theme.palette.text.primary
	},
	notesContainer: {
		backgroundColor: theme.palette.type === "dark" ? "#2a3550" : "#c7c9c9"
	},
	emptyNotesBox: {
		backgroundColor: theme.palette.type === "dark" ? "#2a3550" : "#c7c9c9",
		height: "100%",
		display: "flex",
		justifyContent: "center",
		alignItems: "center",
		fontStyle: "italic",
		color: theme.palette.text.primary
	}
}));

/**
 * SearchConvs Component - DIALOG to search conversations with multiple filters
 * @param {function} handleCloseSearch Function to close this DIALOG
 * @param {Boolean} openSearch variable to open the dialog
 * @param {object} dispatch The initial draft for the engage, can be empty
 */
export function SearchConvs({ handleCloseSearch, openSearch, dispatch }) {
	const { isDarkMode } = useTheme();
	const muiTheme = useMuiTheme();
	const classes = useStyles();
	const [valueSearch, setValueSearch] = useState("");
	const selectedAssistantID = useSelector(state => state.selectedAssistantID);
	const { userStatus, assistantconfig, cockpit } = useSelector(state => state);

	const [intentList, setIntentList] = useState([]);
	const [possibleChannelFilter, setPossibleChannelFilter] = useState([]);
	const [possibleLanguageFilter, setPossibleLanguageFilter] = useState([]);
	const [filtersConv, setFiltersConv] = useState({});
	const [loadingConv, setLoadingConv] = useState(false);
	const [failureLoadingConv, setFailureLoadingConv] = useState(false);
	const [conversationList, setConversationList] = useState([]);
	const [conversationListArchived, setConversationListArchived] = useState([]);
	const [launchSearch, setLaunchSearch] = useState(false);
	const [showMessage, setShowMessage] = useState(false);

	const [widthContent, setWidthContent] = useState(100);

	const [conversationSelected, setConversationSelected] = useState({});

	// Intent Filter Button ON/OFF
	useEffect(() => {
		if (selectedAssistantID) {
			/* BUILD intents list */
			let intentsConfig = assistantconfig.intents;
			if (!lod_.isNil(intentsConfig)) {
				let intentsName = intentsConfig.map(intent => intent.code);
				setIntentList(intentsName);
			}

			/* BUILD possible channel list */
			let channels = getChannelsByAssistant(assistantconfig);
			if (!lod_.isNil(channels)) {
				const sorted = lod_.orderBy(
					channels,
					[
						o => !o.favorite, // false (favoris) avant true
						o => o.tag,
						o => o.name || ""
					],
					["asc", "asc", "asc"]
				);
				setPossibleChannelFilter(sorted);
			} else {
				setPossibleChannelFilter([]);
			}
			/* BUILD language list */
			setPossibleLanguageFilter(getLanguagesByAssistant(assistantconfig));
		}
		setLoadingConv(false);
		setConversationList([]);
		setConversationListArchived([]);
		setFailureLoadingConv(false);
		setLaunchSearch(false);
	}, []);

	const handleConvFilter = (target, newValue) => {
		setFiltersConv(prev => {
			let clonePrev = lod_.cloneDeep(prev);
			clonePrev[target] = newValue;
			return clonePrev;
		});
	};

	/** Launch the search with the filters */
	const handleLauchFilter = () => {
		const filters = {
			search: lod_.isNil(valueSearch) ? "" : valueSearch.trim(),
			channel:
				lod_.isNil(filtersConv?.convChannelFilter) || lod_.isEmpty(filtersConv?.convChannelFilter)
					? null
					: filtersConv?.convChannelFilter?.code?.toUpperCase(),
			language: filtersConv?.convLanguageFilter || "",
			priority: filtersConv?.convPriorityFilter || null,
			sentiment: filtersConv?.convSentimentFilter || null,
			subState: filtersConv?.convSubstateFilter || null,
			connected: filtersConv?.convConnectedFilter || null,
			intent: lod_.isNil(filtersConv?.convIntentFilter) ? [] : filtersConv?.convIntentFilter,
			asc: typeof filtersConv?.convAscFilter !== "boolean" ? true : filtersConv?.convAscFilter,
			startDate: filtersConv?.convStartDateFilter || null,
			endDate: filtersConv?.convEndDateFilter || null,
			groups: lod_.isNil(filtersConv?.convGroupFilter)
				? []
				: filtersConv?.convGroupFilter.map(group => group._id),
			noBot: lod_.isNil(filtersConv?.convNoBotFilter) ? false : filtersConv?.convNoBotFilter,
			direction: lod_.isNil(filtersConv?.convDirectionFilter)
				? ""
				: filtersConv?.convDirectionFilter,
			pathContext:
				lod_.isNil(filtersConv?.convPathContextFilter) ||
				lod_.isEmpty(filtersConv?.convPathContextFilter)
					? {}
					: filtersConv?.convPathContextFilter,
			users: filtersConv?.convUserFilter,
			// do not send agent for waiting (==0) nor for Live (==3)
			agent:
				filtersConv?.convAgentFilter && userStatus?.auth?.user?.role === "agent"
					? userStatus?.auth?.user?.email || ""
					: null,
			supervisor:
				filtersConv?.convSupervisorFilter &&
				(userStatus?.auth?.user?.role === "supervisor" ||
					userStatus?.auth?.user?.role === "soloUser")
					? userStatus?.auth?.user?.email
					: null
		};

		let sort = {
			// "header.humanRequest": -1,
			"meta.cockpit.ts": filters.asc ? -1 : 1,
			"header.start": filters.asc ? -1 : 1
		};

		let role = userStatus?.auth?.user?.role;
		let groups = userStatus?.auth?.user?.groups;
		let escalationGroup = userStatus?.auth?.user?.escalationGroup;

		setLoadingConv(true);

		/** Set state of component to have success in front */
		/** @param {object} res - Response from API AD - List of conversation */
		const onSuccess = res => {
			setConversationList(res);
			setLoadingConv(false);
			setLaunchSearch(true);
		};

		/** Set state of component to have error in front */
		const onFailure = res => {
			setLoadingConv(false);
			setConversationList([]);
			setFailureLoadingConv(true);
			setLaunchSearch(false);
		};

		dispatch(
			api({
				method: "POST",
				type: "cockpit/actionFrontCustom",
				url: `/api/v1/search/conversations/${selectedAssistantID}`,
				data: {
					groups,
					escalationGroup,
					role,
					sort,
					limit: 100, // PIKA : 2025.11.04 - Should be a parameter in Cockpit.limits
					skip: 0,
					filters,
					count: null
				},
				onSuccess,
				onFailure
			})
		);

		/** Set state of component to have success in front for archived convs */
		/** @param {object} res - Response from API AD2 - List of conversation */
		const onSuccessArchived = res => {
			setConversationListArchived(res);
			setLoadingConv(false);
			setLaunchSearch(true);
		};

		/** Set state of component to have error in front for archived convs */
		const onFailureArchived = res => {
			setLoadingConv(false);
			setConversationListArchived([]);
			setFailureLoadingConv(true);
			setLaunchSearch(false);
		};

		/** FBDB-4010 -> CALL AD2 to have no impact for AD to get archived conversation */
		dispatch(
			api2({
				method: "POST",
				type: "cockpit/actionFrontCustom",
				url: `/api/v1/search/conversations/${selectedAssistantID}`,
				data: {
					groups,
					escalationGroup,
					role,
					sort,
					limit: 100, // PIKA : 2025.11.04 - Should be a parameter in Cockpit.limits
					skip: 0,
					filters,
					count: null,
					archivedOnly: true
				},
				onSuccess: onSuccessArchived,
				onFailure: onFailureArchived
			})
		);
	};

	const displayTitleConv = conv => {
		const intents = assistantconfig?.intents || [];

		if (!lod_.isEmpty(conv?.meta?.cockpit?.title)) {
			return getIntentLabel(conv.meta?.cockpit.title, intents);
		}

		return "";
	};

	/** Launch the selection of conversation */
	const selectConv = (state, fID) => {
		if (state === "archived") {
			dispatch(cockpitActions.setIsCockpitArchived(true));

			dispatch({ type: C.CLEAR_CONVERSATION });

			dispatch(cockpitActions.setLeftTab(0));

			dispatch({ type: C.SET_CONVS_RELOAD, payload: true });

			dispatch(
				cockpitActions.forceSearchConversationSelection({
					content: {
						header: {
							assistantID: selectedAssistantID,
							fID
						}
					}
				})
			);
		} else if (state === "hidden") {
			dispatch(cockpitActions.setIsCockpitArchived(true));
			dispatch({ type: C.CLEAR_CONVERSATION });

			dispatch(cockpitActions.setLeftTab(1));

			dispatch({ type: C.SET_CONVS_RELOAD, payload: true });

			dispatch(
				cockpitActions.forceSearchConversationSelection({
					content: {
						header: {
							assistantID: selectedAssistantID,
							fID
						}
					}
				})
			);
		} else {
			dispatch(cockpitActions.setIsCockpitArchived(false));
			dispatch({ type: C.CLEAR_CONVERSATION });
			dispatch({ type: C.SET_CONVS_RELOAD, payload: true });

			dispatch(
				cockpitActions.forceSearchConversationSelection(
					{
						content: {
							header: {
								assistantID: selectedAssistantID,
								fID
							}
						}
					},
					1
				)
			);
		}

		handleCloseSearch();
	};

	/** Launch get message of conversation and show messages */
	const handleShowMessage = item => {
		if (lod_.isNil(item?.header?.fID)) {
			return;
		}

		setShowMessage(true);
		setWidthContent(40);
		/** Set state of component to have success in front */
		const onSuccess = res => {
			if (!lod_.isNil(res)) {
				if (
					userStatus?.auth?.user?.cockpitSettings?.forceMessageSortNewerToOlder &&
					!lod_.isNil(res.messages)
				) {
					res.messages.sort((a, b) => {
						return getTsOfMessage(b) - getTsOfMessage(a);
					});
				}
				setConversationSelected(res);
			} else {
				setConversationSelected({});
			}
		};

		/** Set state of component to have error in front */
		const onFailure = res => {
			setConversationSelected({});
		};

		dispatch(
			api({
				method: "POST",
				type: "cockpit/actionFrontCustom",
				url: `/api/v1//messages/conversation/${item?.header?.fID}/${selectedAssistantID}`,
				data: {
					state: item?.header?.state
				},
				onSuccess,
				onFailure
			})
		);
	};

	return (
		<Dialog
			fullWidth
			open={openSearch}
			maxWidth={false}
			onClose={handleCloseSearch}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogTitle id="alert-dialog-title">
				<Box display={"flex"} flexDirection={"row"} alignItems={"center"}>
					<Typography style={{ paddingRight: "1%" }}>{i18n.t("COC.listConversations")}</Typography>
					{(!lod_.isEmpty(conversationList) || !lod_.isEmpty(conversationListArchived)) && (
						<Chip
							label={`${conversationList.length + conversationListArchived.length}`}
							color={"primary"}
							clickable={false}
						/>
					)}
				</Box>
			</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<Box style={{ display: "flex", height: "100%", width: "100%" }}>
					{/* Colonne gauche */}
					<Box className={classes.leftColumn} style={{ width: `${widthContent}%` }}>
						<Box width={"100%"}>
							<Typography className={classes.filterLabel}>
								{i18n.t("COC.supervisorFilterConv")}
							</Typography>
							<Box
								mt={1}
								display={"flex"}
								alignItems={"center"}
								flexDirection={"row"}
								width={"100%"}
							>
								<Box mr={1} flex={1}>
									<TextField
										onChange={e => setValueSearch(e.target.value)}
										onKeyDown={e => {
											if (e.key === "Enter" && !lod_.isEmpty(e.target.value.trim())) {
												e.preventDefault();
												handleLauchFilter();
											}
										}}
										value={valueSearch}
										fullWidth
										variant="outlined"
										size="small"
										className={classes.searchTextField}
										InputProps={{
											startAdornment: (
												<InputAdornment position="start">
													<SearchIcon />
												</InputAdornment>
											),
											endAdornment: (
												<IconButton
													size="small"
													onClick={() => setValueSearch("")}
													className={classes.iconButton}
												>
													{valueSearch?.trim().length > 0 && <ClearIcon />}
												</IconButton>
											)
										}}
									/>
								</Box>

								<Box>
									<Button
										variant="contained"
										color="primary"
										onClick={handleLauchFilter}
										disabled={lod_.isEmpty(valueSearch.trim())}
									>
										{i18n.t("COC.search")}
									</Button>
								</Box>
							</Box>
							<Box mt={1}>
								<FiltersSearch
									// Role of the user
									role={userStatus.auth.user.role}
									// Filtre change object
									handleConvChangeFilter={handleConvFilter}
									// Filtre possible channel
									possibleChannelFilter={possibleChannelFilter}
									// Filtre possible language
									possibleLanguageFilter={possibleLanguageFilter}
									// Filtre possible intent
									intentList={intentList}
								/>
							</Box>
						</Box>
						{loadingConv && (
							<Box
								style={{
									width: "100%",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									alignItems: "center",
									height: "80%"
								}}
							>
								<Box mb={5}>
									<CircularProgress size={100} mb={8} />
								</Box>
								<Typography className={classes.emptyStateText}>
									{i18n.t("COC.loadingConversations")}
								</Typography>
							</Box>
						)}
						{failureLoadingConv && (
							<Box
								style={{
									width: "100%",
									display: "flex",
									flexDirection: "column",
									justifyContent: "center",
									alignItems: "center",
									height: "80%"
								}}
							>
								<Typography className={classes.emptyStateText} color="error">
									{i18n.t("COC.errorLoadingConversations")}
								</Typography>
							</Box>
						)}

						<Box
							style={{
								display: "flex",
								flexDirection: "column",
								height: "100%",
								overflowY: "auto"
							}}
						>
							{/* Message "aucune conversation" uniquement si les deux listes sont vides */}
							{launchSearch &&
								lod_.isEmpty(conversationList) &&
								lod_.isEmpty(conversationListArchived) && (
									<Box
										style={{
											width: "100%",
											display: "flex",
											flexDirection: "column",
											justifyContent: "center",
											alignItems: "center",
											height: "80%"
										}}
									>
										<Typography className={classes.emptyStateText}>
											{i18n.t("COC.noElementConv")}
										</Typography>
									</Box>
								)}

							{/* Liste des conversations actives */}
							{launchSearch && !lod_.isEmpty(conversationList) && (
								<List style={{ flex: 1 }}>
									{conversationList.map((item, index) => (
										<Box style={{ width: "100%" }} key={index}>
											<ListItem
												key={index}
												button
												selected={conversationSelected?.header?.fID === item?.header?.fID}
												onClick={() => handleShowMessage(item)}
												className={classes.listItem}
											>
												<ListItemIcon>
													<Tooltip title={i18n.t("COC.showConversation")} placement="top">
														<IconButton
															edge="end"
															onClick={() => selectConv(item?.header?.state, item?.header?.fID)}
															className={classes.visibilityIcon}
														>
															<VisibilityIcon />
														</IconButton>
													</Tooltip>
												</ListItemIcon>
												<ListItemAvatar>
													<img
														src={GetChannelImage(
															assistantconfig?.channels,
															item.meta?.cockpit?.channelCode,
															item?.header?.channel?.toUpperCase()
														)}
														alt="Channel-logo"
														width="30"
														height="30"
														className="logo-channel"
													/>
												</ListItemAvatar>
												<ListItemText
													style={{ width: "100%" }}
													className={classes.listItemText}
													primary={
														displayTitleConv(item) + " " + `(${item?.meta?.cockpit?.contact})`
													}
													secondary={
														(assistantconfig?.cockpit?.datetime_format?.format
															? handleSpecialDisplayDate(
																	item?.meta?.cockpit?.ts,
																	assistantconfig?.cockpit?.datetime_format?.format,
																	userStatus?.auth?.user?.language?.toLowerCase() || "fr"
																)
															: formatDate(item?.meta?.cockpit?.datetime)) +
														" | " +
														item?.header?.fID
													}
												/>
											</ListItem>
										</Box>
									))}
								</List>
							)}
							{/* Séparation entre conversations "normales" et archivées */}
							{launchSearch && !lod_.isEmpty(conversationListArchived) && (
								<Box mt={2} mb={1}>
									<Box display="flex" alignItems="center" mt={1} mb={1}>
										<Typography
											variant="subtitle1"
											className={classes.filterLabel}
											style={{ fontWeight: "bold", marginBottom: 0 }}
										>
											{i18n.t("COC.archivedConversations")}
										</Typography>
									</Box>
								</Box>
							)}

							{/* Listing des conversations archivée(s) */}
							{!lod_.isEmpty(conversationListArchived) && launchSearch && (
								<List style={{ flex: 1 }}>
									{conversationListArchived.map((item, index) => (
										<Box style={{ width: "100%" }} key={index}>
											<ListItem
												key={index}
												button
												selected={conversationSelected?.header?.fID === item?.header?.fID}
												onClick={() => handleShowMessage(item)}
												className={classes.listItem}
											>
												<ListItemIcon>
													<Tooltip title={i18n.t("COC.showConversation")} placement="top">
														<IconButton
															edge="end"
															onClick={() => selectConv(item?.header?.state, item?.header?.fID)}
															className={classes.visibilityIcon}
														>
															<VisibilityIcon />
														</IconButton>
													</Tooltip>
												</ListItemIcon>
												<ListItemAvatar>
													<img
														src={GetChannelImage(
															assistantconfig?.channels,
															item.meta?.cockpit?.channelCode,
															item?.header?.channel?.toUpperCase()
														)}
														alt="Channel-logo"
														width="30"
														height="30"
														className="logo-channel"
													/>
												</ListItemAvatar>
												<ListItemText
													style={{ width: "100%" }}
													className={classes.listItemText}
													primary={
														displayTitleConv(item) + " " + `(${item?.meta?.cockpit?.contact})`
													}
													secondary={
														(assistantconfig?.cockpit?.datetime_format?.format
															? handleSpecialDisplayDate(
																	item?.meta?.cockpit?.ts,
																	assistantconfig?.cockpit?.datetime_format?.format,
																	userStatus?.auth?.user?.language?.toLowerCase() || "fr"
																)
															: formatDate(item?.meta?.cockpit?.datetime)) +
														" | " +
														item?.header?.fID
													}
												/>
											</ListItem>
										</Box>
									))}
								</List>
							)}
						</Box>
					</Box>

					{/* Colonne droite */}
					{showMessage && (
						<Box className={classes.rightColumn}>
							{lod_.isEmpty(conversationSelected) ? (
								<Box className={classes.noMessagesBox}>{i18n.t("COC.noMessagesFound")}</Box>
							) : (
								<>
									{conversationSelected.header.type === "call" ? (
										<>
											{!lod_.isNil(conversationSelected?.meta?.cockpit?.summary) &&
											!lod_.isEmpty(conversationSelected?.meta?.cockpit?.summary) ? (
												<Summary conversation={conversationSelected} />
											) : (
												<>
													{!lod_.isEmpty(conversationSelected.notes) ? (
														<Box className={classes.notesContainer}>
															<NotesComponent
																notes={conversationSelected.notes}
																deleteNote={false}
															/>
														</Box>
													) : (
														<Box className={classes.emptyNotesBox}>
															{i18n.t("COC.emptyNotesSummary")}
														</Box>
													)}
												</>
											)}
										</>
									) : (
										<Box>
											{!lod_.isNil(conversationSelected?.meta?.cockpit?.summary) &&
												!lod_.isEmpty(conversationSelected?.meta?.cockpit?.summary) && (
													<Summary conversation={conversationSelected} />
												)}
											{conversationSelected?.messages.map((mess, index) => (
												<Box
													key={index}
													className={classes.messageContainer}
													style={{
														backgroundColor: isDarkMode ? "var(--dark-bg-primary)" : ""
													}}
												>
													<MessageItem
														key={`${mess?.header?.mID} -${index}`}
														message={mess}
														msgIndex={index}
														fromHistoric={true}
														displayForwardedMessages={true}
														convHistory={conversationSelected}
													/>
												</Box>
											))}
										</Box>
									)}
								</>
							)}
						</Box>
					)}
				</Box>
			</DialogContent>
			<DialogActions>
				<Button color="secondary" onClick={handleCloseSearch}>
					{`${i18n.t("COC.Cancel")}`}
				</Button>
			</DialogActions>
		</Dialog>
	);
}
